import { EventBus } from '@/EventBus.js';


export default {
  name: 'dialog-panel',

  data: function () {
    return {
      key:"pair",
      message:null,
      options:null,
      timeout:null,
      panelOpen:false
    }
  },

  mounted:function() {
    // Listen for global events
    EventBus.$on( 'dialogEvent', this.onDialogEvent );
    EventBus.$on( 'errorEvent', this.onDialogEvent );
  },

  beforeDestroy: function() {
    // Release event listeners
    EventBus.$off( 'dialogEvent' );
    EventBus.$off( 'errorEvent' );
  },

  methods: {
    /**
      * An event which requires a dialog panel has been recieved
      *
      * @param { string } The message we want to display in the dialog panel
      * @param { array } Options for the user to select from in the of the form { optionText:optionText , optionEvent:optionEvent }
      */
    onDialogEvent:function( message, options ){

      this.panelOpen = true;
      this.message = message;
      this.options = [];

      if( options ) this.options = options;

      // Clear old timeout
      if( this.timeout ) clearTimeout( this.timeout );

      // If we have no options clese panel after a period
      if( this.options.length == 0 )
      {
        this.timeout = setTimeout( ()=>{ this.closePanel() }, 4000 );
      }
    },

    /**
      * One of the options in the current dialog has been clicked
      * We look up the optionEvent for that option e.g. "delteConfirmed" then emit that event.
      * If the option has and optionData this will also be emitted.
      *
      * @param { int } The index of the clicked option
      */
    onOptionClick:function( optionIndex ){

      let clickedOptionEventName = this.options[optionIndex].optionEvent;

      // If we have a clickedOptionEventName then we fire an event
      if( clickedOptionEventName )
      {
        let data = this.options[optionIndex].optionData;
        EventBus.$emit( clickedOptionEventName , data);
      }

      // Close the panel
      this.closePanel();
    },

    /**
      * Close the panel
      */
    closePanel:function(){

      this.panelOpen = false;
    }
  },

  computed:{


  }
}



// WEBPACK FOOTER //
// ./src/components/ui/DialogPanel/DialogPanel.js